import {
  Checkbox,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { useTranslate } from 'src/localization/Trns'
import { ConnectedPlatformStatus } from 'src/models/transaction.models'
import { css } from 'styled-components'

interface ReceiptSyncStatusFilterProps {
  receiptAttachmentSyncStatusesSet: Set<string>
  handleReceiptAttachmentSyncStatusesSelection: (status: string) => Set<string>
}

const ReceiptSyncStatusFilter: React.FC<ReceiptSyncStatusFilterProps> = ({
  receiptAttachmentSyncStatusesSet,
  handleReceiptAttachmentSyncStatusesSelection,
}) => {
  const translate = useTranslate()

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 12px;
      `}
    >
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        {translate('Receipt Sync')}
      </div>
      <Checkbox
        label={translate('Synced')}
        onClick={(): void => {
          handleReceiptAttachmentSyncStatusesSelection(
            ConnectedPlatformStatus.Success,
          )
        }}
        isSelected={receiptAttachmentSyncStatusesSet.has(
          ConnectedPlatformStatus.Success,
        )}
      />
      <Checkbox
        label={translate('Not synced')}
        onClick={(): void => {
          handleReceiptAttachmentSyncStatusesSelection(
            ConnectedPlatformStatus.NotSynced,
          )
        }}
        isSelected={receiptAttachmentSyncStatusesSet.has(
          ConnectedPlatformStatus.NotSynced,
        )}
      />
      <Checkbox
        label={translate('Sync failed')}
        onClick={(): void => {
          handleReceiptAttachmentSyncStatusesSelection(
            ConnectedPlatformStatus.Failed,
          )
        }}
        isSelected={receiptAttachmentSyncStatusesSet.has(
          ConnectedPlatformStatus.Failed,
        )}
      />
      <Checkbox
        label={translate('Sync in progress')}
        onClick={(): void => {
          handleReceiptAttachmentSyncStatusesSelection(
            ConnectedPlatformStatus.Pending,
          )
        }}
        isSelected={receiptAttachmentSyncStatusesSet.has(
          ConnectedPlatformStatus.Pending,
        )}
      />
    </div>
  )
}

export default ReceiptSyncStatusFilter
